import { CheckCircle2, Award, GraduationCap, Heart } from "lucide-react";

const DoctorSection = () => {
  const specializations = [
    "Diastasis Recti Rehabilitation",
    "Post Pregnancy Recovery",
    "Women-Centric Physiotherapy",
    "Manual Therapy & Core Strength Rehab",
  ];

  const qualityPoints = [
    { icon: CheckCircle2, text: "Personalized" },
    { icon: CheckCircle2, text: "Safe" },
    { icon: CheckCircle2, text: "Evidence-Based" },
    { icon: CheckCircle2, text: "Non-Surgical" },
  ];

  return (
    <section id="about" className="section-spacing bg-stone-50" data-testid="doctor-section">
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative">
              <img
                src="/images/drseema.jpeg"
                alt="Dr. Seema Chaudhary - Expert Physiotherapist"
                className="rounded-3xl shadow-xl w-full h-auto object-cover"
                data-testid="doctor-image"
              />

              {/* Experience Badge */}
              <div className="absolute -top-4 -right-4 bg-blue-700 text-white rounded-2xl p-4 shadow-lg" data-testid="experience-badge">
                <p className="text-3xl font-bold">17+</p>
                <p className="text-sm">Years Exp.</p>
              </div>

              {/* Patients Badge */}
              <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl p-4 shadow-lg border border-blue-100" data-testid="patients-badge">
                <div className="flex items-center gap-3">
                  <Heart className="text-pink-500" fill="currentColor" size={24} />
                  <div>
                    <p className="text-2xl font-bold text-blue-900">7000+</p>
                    <p className="text-xs text-stone-500">Women Helped</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 bg-pink-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <GraduationCap size={16} />
              DPT, BPT & DR Certified
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-testid="doctor-name">
              Meet Dr. Seema Chaudhary
            </h2>

            <p className="text-lg text-stone-600 mb-6" data-testid="doctor-intro">
              With over <strong className="text-blue-700">17 years of clinical experience</strong>, Dr. Seema specializes in helping women reclaim their core strength and confidence after pregnancy.
            </p>

            {/* Specializations */}
            <div className="mb-8">
              <h3 className="text-lg font-semibold text-blue-900 mb-4 flex items-center gap-2">
                <Award className="text-blue-600" size={20} />
                Specializations
              </h3>
              <ul className="space-y-3" data-testid="specialization-list">
                {specializations.map((spec, index) => (
                  <li key={index} className="flex items-center gap-3 text-stone-700">
                    <CheckCircle2 className="text-emerald-500 flex-shrink-0" size={18} />
                    {spec}
                  </li>
                ))}
              </ul>
            </div>

            {/* Approach */}
            <div className="bg-white rounded-2xl p-6 border border-blue-100">
              <p className="text-stone-700 mb-4">
                She has successfully helped <strong className="text-blue-700">7000+ women</strong> regain confidence and core stability. Her approach is:
              </p>
              <div className="grid grid-cols-2 gap-3" data-testid="approach-points">
                {qualityPoints.map((point, index) => (
                  <div key={index} className="flex items-center gap-2 text-stone-700">
                    <point.icon className="text-blue-600" size={18} />
                    <span className="font-medium">{point.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DoctorSection;
